// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces/index';

export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class Via implements i.ViaInterface {
  channel: string;

  static fromProto(proto: any): Via {
    let m = new Via();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: i.ViaInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (typeof this.channel === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.channel !== 'undefined') {
      toReturn['channel'] = this.channel;
    }
    return toReturn;
  }
}

export class Ticket implements i.TicketInterface {
  id: number;
  url: string;
  status: string;
  priority: string;
  type: string;
  subject: string;
  description: string;
  organizationId: number;
  requester: User;
  collaborators: User[];
  dueAt: Date;
  createdAt: Date;
  updatedAt: Date;
  recipient: string;
  followupSourceId: number;
  assignee: User;
  group: Group;
  via: Via;
  tags: string[];
  comment: TicketComment;

  static fromProto(proto: any): Ticket {
    let m = new Ticket();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.organizationId) {
      m.organizationId = parseInt(proto.organizationId, 10);
    }
    if (proto.requester) {
      m.requester = User.fromProto(proto.requester);
    }
    if (proto.collaborators) {
      m.collaborators = proto.collaborators.map(User.fromProto);
    }
    if (proto.dueAt) {
      m.dueAt = new Date(proto.dueAt);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.followupSourceId) {
      m.followupSourceId = parseInt(proto.followupSourceId, 10);
    }
    if (proto.assignee) {
      m.assignee = User.fromProto(proto.assignee);
    }
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    if (proto.via) {
      m.via = Via.fromProto(proto.via);
    }
    if (proto.comment) {
      m.comment = TicketComment.fromProto(proto.comment);
    }
    return m;
  }

  constructor(kwargs?: i.TicketInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.id === 'undefined' &&
      typeof this.url === 'undefined' &&
      typeof this.status === 'undefined' &&
      typeof this.priority === 'undefined' &&
      typeof this.type === 'undefined' &&
      typeof this.subject === 'undefined' &&
      typeof this.description === 'undefined' &&
      typeof this.organizationId === 'undefined' &&
      typeof this.requester === 'undefined' &&
      typeof this.collaborators === 'undefined' &&
      typeof this.dueAt === 'undefined' &&
      typeof this.createdAt === 'undefined' &&
      typeof this.updatedAt === 'undefined' &&
      typeof this.recipient === 'undefined' &&
      typeof this.followupSourceId === 'undefined' &&
      typeof this.assignee === 'undefined' &&
      typeof this.group === 'undefined' &&
      typeof this.via === 'undefined' &&
      typeof this.tags === 'undefined' &&
      typeof this.comment === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.priority !== 'undefined') {
      toReturn['priority'] = this.priority;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.requester !== 'undefined' && this.requester !== null) {
      toReturn['requester'] = 'toApiJson' in this.requester ? (this.requester as any).toApiJson() : this.requester;
    }
    if (typeof this.collaborators !== 'undefined' && this.collaborators !== null) {
      toReturn['collaborators'] =
        'toApiJson' in this.collaborators ? (this.collaborators as any).toApiJson() : this.collaborators;
    }
    if (typeof this.dueAt !== 'undefined' && this.dueAt !== null) {
      toReturn['dueAt'] = 'toApiJson' in this.dueAt ? (this.dueAt as any).toApiJson() : this.dueAt;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? (this.createdAt as any).toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? (this.updatedAt as any).toApiJson() : this.updatedAt;
    }
    if (typeof this.recipient !== 'undefined') {
      toReturn['recipient'] = this.recipient;
    }
    if (typeof this.followupSourceId !== 'undefined') {
      toReturn['followupSourceId'] = this.followupSourceId;
    }
    if (typeof this.assignee !== 'undefined' && this.assignee !== null) {
      toReturn['assignee'] = 'toApiJson' in this.assignee ? (this.assignee as any).toApiJson() : this.assignee;
    }
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? (this.group as any).toApiJson() : this.group;
    }
    if (typeof this.via !== 'undefined' && this.via !== null) {
      toReturn['via'] = 'toApiJson' in this.via ? (this.via as any).toApiJson() : this.via;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.comment !== 'undefined' && this.comment !== null) {
      toReturn['comment'] = 'toApiJson' in this.comment ? (this.comment as any).toApiJson() : this.comment;
    }
    return toReturn;
  }
}

export class User implements i.UserInterface {
  id: number;
  url: string;
  name: string;
  externalId: string;
  alias: string;
  createdAt: Date;
  updatedAt: Date;
  active: boolean;
  verified: boolean;
  shared: boolean;
  sharedAgent: boolean;
  locale: boolean;
  localeId: number;
  timeZone: string;
  lastLoginAt: Date;
  email: string;
  phone: string;
  signature: string;
  details: string;
  notes: string;
  organizationId: number;
  role: string;
  customRoleId: number;
  moderator: boolean;
  ticketRestriction: string;
  onlyPrivateComments: boolean;
  tags: string[];
  restrictedAgent: boolean;
  suspended: boolean;

  static fromProto(proto: any): User {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.localeId) {
      m.localeId = parseInt(proto.localeId, 10);
    }
    if (proto.lastLoginAt) {
      m.lastLoginAt = new Date(proto.lastLoginAt);
    }
    if (proto.organizationId) {
      m.organizationId = parseInt(proto.organizationId, 10);
    }
    if (proto.customRoleId) {
      m.customRoleId = parseInt(proto.customRoleId, 10);
    }
    return m;
  }

  constructor(kwargs?: i.UserInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.id === 'undefined' &&
      typeof this.url === 'undefined' &&
      typeof this.name === 'undefined' &&
      typeof this.externalId === 'undefined' &&
      typeof this.alias === 'undefined' &&
      typeof this.createdAt === 'undefined' &&
      typeof this.updatedAt === 'undefined' &&
      typeof this.active === 'undefined' &&
      typeof this.verified === 'undefined' &&
      typeof this.shared === 'undefined' &&
      typeof this.sharedAgent === 'undefined' &&
      typeof this.locale === 'undefined' &&
      typeof this.localeId === 'undefined' &&
      typeof this.timeZone === 'undefined' &&
      typeof this.lastLoginAt === 'undefined' &&
      typeof this.email === 'undefined' &&
      typeof this.phone === 'undefined' &&
      typeof this.signature === 'undefined' &&
      typeof this.details === 'undefined' &&
      typeof this.notes === 'undefined' &&
      typeof this.organizationId === 'undefined' &&
      typeof this.role === 'undefined' &&
      typeof this.customRoleId === 'undefined' &&
      typeof this.moderator === 'undefined' &&
      typeof this.ticketRestriction === 'undefined' &&
      typeof this.onlyPrivateComments === 'undefined' &&
      typeof this.tags === 'undefined' &&
      typeof this.restrictedAgent === 'undefined' &&
      typeof this.suspended === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.alias !== 'undefined') {
      toReturn['alias'] = this.alias;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? (this.createdAt as any).toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? (this.updatedAt as any).toApiJson() : this.updatedAt;
    }
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.verified !== 'undefined') {
      toReturn['verified'] = this.verified;
    }
    if (typeof this.shared !== 'undefined') {
      toReturn['shared'] = this.shared;
    }
    if (typeof this.sharedAgent !== 'undefined') {
      toReturn['sharedAgent'] = this.sharedAgent;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.localeId !== 'undefined') {
      toReturn['localeId'] = this.localeId;
    }
    if (typeof this.timeZone !== 'undefined') {
      toReturn['timeZone'] = this.timeZone;
    }
    if (typeof this.lastLoginAt !== 'undefined' && this.lastLoginAt !== null) {
      toReturn['lastLoginAt'] =
        'toApiJson' in this.lastLoginAt ? (this.lastLoginAt as any).toApiJson() : this.lastLoginAt;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.signature !== 'undefined') {
      toReturn['signature'] = this.signature;
    }
    if (typeof this.details !== 'undefined') {
      toReturn['details'] = this.details;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.customRoleId !== 'undefined') {
      toReturn['customRoleId'] = this.customRoleId;
    }
    if (typeof this.moderator !== 'undefined') {
      toReturn['moderator'] = this.moderator;
    }
    if (typeof this.ticketRestriction !== 'undefined') {
      toReturn['ticketRestriction'] = this.ticketRestriction;
    }
    if (typeof this.onlyPrivateComments !== 'undefined') {
      toReturn['onlyPrivateComments'] = this.onlyPrivateComments;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.restrictedAgent !== 'undefined') {
      toReturn['restrictedAgent'] = this.restrictedAgent;
    }
    if (typeof this.suspended !== 'undefined') {
      toReturn['suspended'] = this.suspended;
    }
    return toReturn;
  }
}

export class Group implements i.GroupInterface {
  id: number;
  url: string;
  name: string;
  deleted: boolean;
  createdAt: Date;
  updatedAt: Date;

  static fromProto(proto: any): Group {
    let m = new Group();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    return m;
  }

  constructor(kwargs?: i.GroupInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.id === 'undefined' &&
      typeof this.url === 'undefined' &&
      typeof this.name === 'undefined' &&
      typeof this.deleted === 'undefined' &&
      typeof this.createdAt === 'undefined' &&
      typeof this.updatedAt === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.deleted !== 'undefined') {
      toReturn['deleted'] = this.deleted;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? (this.createdAt as any).toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? (this.updatedAt as any).toApiJson() : this.updatedAt;
    }
    return toReturn;
  }
}

export class Attachment implements i.AttachmentInterface {
  id: number;
  fileName: string;
  contentUrl: string;
  contentType: string;
  size: number;
  inline: boolean;

  static fromProto(proto: any): Attachment {
    let m = new Attachment();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.size) {
      m.size = parseInt(proto.size, 10);
    }
    return m;
  }

  constructor(kwargs?: i.AttachmentInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.id === 'undefined' &&
      typeof this.fileName === 'undefined' &&
      typeof this.contentUrl === 'undefined' &&
      typeof this.contentType === 'undefined' &&
      typeof this.size === 'undefined' &&
      typeof this.inline === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    if (typeof this.contentUrl !== 'undefined') {
      toReturn['contentUrl'] = this.contentUrl;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    if (typeof this.inline !== 'undefined') {
      toReturn['inline'] = this.inline;
    }
    return toReturn;
  }
}

export class TicketComment implements i.TicketCommentInterface {
  id: number;
  type: string;
  body: string;
  htmlBody: string;
  public: boolean;
  authorId: number;
  attachments: Attachment[];
  createdAt: Date;

  static fromProto(proto: any): TicketComment {
    let m = new TicketComment();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.authorId) {
      m.authorId = parseInt(proto.authorId, 10);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    return m;
  }

  constructor(kwargs?: i.TicketCommentInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.id === 'undefined' &&
      typeof this.type === 'undefined' &&
      typeof this.body === 'undefined' &&
      typeof this.htmlBody === 'undefined' &&
      typeof this.public === 'undefined' &&
      typeof this.authorId === 'undefined' &&
      typeof this.attachments === 'undefined' &&
      typeof this.createdAt === 'undefined'
    ) {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.htmlBody !== 'undefined') {
      toReturn['htmlBody'] = this.htmlBody;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    if (typeof this.authorId !== 'undefined') {
      toReturn['authorId'] = this.authorId;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] =
        'toApiJson' in this.attachments ? (this.attachments as any).toApiJson() : this.attachments;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? (this.createdAt as any).toApiJson() : this.createdAt;
    }
    return toReturn;
  }
}
